/**
 * Payment related reducer functions
 */

import { orderCompleted } from '../analytics'
import { cartEmpty } from '../initialState'

/**
 * Handle payment completion
 * @param {Object} global - Global state
 * @param {Function} dispatch - Dispatch function
 * @param {Object} order - Completed order
 */
export const paymentComplete = (global, dispatch, order) => {
  // Always clear cart on payment complete
  if (order) {
    orderCompleted(order)
  }

  // Preserve customer information so they don't have to fill it in again
  // Preserve address if it has any meaningful data (address1, city, country_code, etc.)
  // Don't require 'complete' flag - preserve any address data the user has entered
  const hasAddressData = global.shipping_address && (
    global.shipping_address.address1 ||
    global.shipping_address.city ||
    global.shipping_address.country_code ||
    global.shipping_address.zip ||
    global.shipping_address.name
  )

  const preservedCustomerInfo = {
    emailAddress: global.emailAddress || "",
    fullName: global.fullName || "",
    contactNumber: global.contactNumber || "",
    shipping_address: hasAddressData
      ? { ...global.shipping_address }
      : { ...cartEmpty.shipping_address },
  }

  return {
    ss: {},
    pd: {},
    ts: {
      pc: false,
    },
    ...cartEmpty,
    // Preserve customer information for next checkout
    ...preservedCustomerInfo,
    // Preserve cartOpen state to prevent unwanted closing during payment
    cartOpen: false
  }
}
